var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_077-bathtub-1",
    "data-name": "077-bathtub-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.331,
    height: 91.332,
    viewBox: "0 0 91.331 91.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_110",
    "data-name": "Grupo 110",
    transform: "translate(15.221 16.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_109",
    "data-name": "Grupo 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_211",
    "data-name": "Trazado 211",
    d: "M86.089,88a6.089,6.089,0,1,0,6.089,6.089A6.089,6.089,0,0,0,86.089,88Zm0,9.133a3.044,3.044,0,1,1,3.044-3.044A3.044,3.044,0,0,1,86.089,97.133Z",
    transform: "translate(-80 -88)",
    fill: "#86888b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_112",
    "data-name": "Grupo 112",
    transform: "translate(35.009 21.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_111",
    "data-name": "Grupo 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_212",
    "data-name": "Trazado 212",
    d: "M188.566,112a4.567,4.567,0,1,0,4.567,4.567A4.566,4.566,0,0,0,188.566,112Zm0,6.089a1.522,1.522,0,1,1,1.522-1.522A1.522,1.522,0,0,1,188.566,118.089Z",
    transform: "translate(-184 -112)",
    fill: "#86888b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_114",
    "data-name": "Grupo 114",
    transform: "translate(30.443 12.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_113",
    "data-name": "Grupo 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_213",
    "data-name": "Trazado 213",
    d: "M162.283,64a2.283,2.283,0,1,0,2.283,2.283A2.283,2.283,0,0,0,162.283,64Zm0,3.044a.761.761,0,1,1,.761-.761A.761.761,0,0,1,162.283,67.044Z",
    transform: "translate(-160 -64)",
    fill: "#86888b"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_116",
    "data-name": "Grupo 116",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_115",
    "data-name": "Grupo 115",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214",
    "data-name": "Trazado 214",
    d: "M91.286,53.442A3.789,3.789,0,0,0,89.129,50.6a9.972,9.972,0,0,0,.682-3.41,7.611,7.611,0,0,0-4.567-6.965V7.611a7.611,7.611,0,1,0-15.222,0v.035a7.946,7.946,0,0,0-7.611,7.576,1.522,1.522,0,0,0,1.522,1.522h13.7a1.522,1.522,0,0,0,1.522-1.522,7.763,7.763,0,0,0-6.089-7.316v-.3a4.567,4.567,0,1,1,9.133,0V39.576a7.36,7.36,0,0,0-2.015.283,12.928,12.928,0,0,0-24.228-1.805,10.587,10.587,0,0,0-1.719.205A7.565,7.565,0,0,0,41.83,35.722,12.907,12.907,0,0,0,22.569,36.9a10.648,10.648,0,0,0-12.444,5.784,7.57,7.57,0,0,0-8.6,7.55v.779A3.783,3.783,0,0,0,3.2,57.78l.965,9.182a21.708,21.708,0,0,0,12.5,16.943l-.609,2.411a4.037,4.037,0,0,0,7.276,3.216l2.018-3.028a29.12,29.12,0,0,0,3.708.259H62.284a29.122,29.122,0,0,0,3.708-.259l2.02,3.029a4.037,4.037,0,0,0,7.273-3.227L74.676,83.9a21.708,21.708,0,0,0,12.5-16.937l.965-9.182A3.789,3.789,0,0,0,91.286,53.442ZM73.407,11.3a5.668,5.668,0,0,1,2.4,2.4H65.76A5.667,5.667,0,0,1,73.407,11.3ZM9.135,45.665a4.535,4.535,0,0,1,1.443.262,1.522,1.522,0,0,0,1.929-.955l.012-.036a7.6,7.6,0,0,1,9.506-5.022q.289.089.57.2a1.522,1.522,0,0,0,1.836-.585,9.871,9.871,0,0,1,16.251-.493,1.522,1.522,0,0,0,2.548-.16,4.532,4.532,0,0,1,8.45,1.5,1.522,1.522,0,0,0,2.028,1.192,7.565,7.565,0,0,1,2.617-.473c.152,0,.3.012.546.03a1.556,1.556,0,0,0,1.54-1.015,9.883,9.883,0,0,1,19.141,2.064,1.522,1.522,0,0,0,2.3,1.117,4.493,4.493,0,0,1,2.349-.674,4.566,4.566,0,0,1,4.567,4.567,6.606,6.606,0,0,1-.8,3.044H4.569A4.566,4.566,0,0,1,9.135,45.665ZM20.794,87.843A.994.994,0,0,1,19,87.053l.486-1.935a26.673,26.673,0,0,0,2.588.8Zm51.36.061h0a.968.968,0,0,1-.781.382.988.988,0,0,1-.825-.441l-1.282-1.93a27,27,0,0,0,2.588-.8l.484,1.932A.976.976,0,0,1,72.153,87.9Zm12-21.26C83.124,76.38,73.724,83.719,62.284,83.719H29.052c-11.441,0-20.84-7.34-21.866-17.076l-.927-8.8H85.077ZM87.527,54.8H3.808a.761.761,0,1,1,0-1.522H87.527a.761.761,0,1,1,0,1.522Z",
    transform: "translate(-0.003)",
    fill: "#003082"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118",
    transform: "translate(62.408 19.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_215",
    "data-name": "Trazado 215",
    d: "M329.522,104A1.522,1.522,0,0,0,328,105.522v4.566a1.522,1.522,0,1,0,3.044,0v-4.566A1.522,1.522,0,0,0,329.522,104Z",
    transform: "translate(-328 -104)",
    fill: "#86888b"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(66.975 18.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_216",
    "data-name": "Trazado 216",
    d: "M353.522,96A1.522,1.522,0,0,0,352,97.522v3.044a1.522,1.522,0,1,0,3.044,0V97.522A1.522,1.522,0,0,0,353.522,96Z",
    transform: "translate(-352 -96)",
    fill: "#86888b"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122",
    transform: "translate(71.542 19.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_121",
    "data-name": "Grupo 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_217",
    "data-name": "Trazado 217",
    d: "M377.522,104A1.522,1.522,0,0,0,376,105.522v4.566a1.522,1.522,0,1,0,3.044,0v-4.566A1.522,1.522,0,0,0,377.522,104Z",
    transform: "translate(-376 -104)",
    fill: "#86888b"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    transform: "translate(76.108 18.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218",
    "data-name": "Trazado 218",
    d: "M401.522,96A1.522,1.522,0,0,0,400,97.522v3.044a1.522,1.522,0,1,0,3.044,0V97.522A1.522,1.522,0,0,0,401.522,96Z",
    transform: "translate(-400 -96)",
    fill: "#86888b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.987cc6e35688b5df509d639c5b7e3e59.svg";
export { ForwardRef as ReactComponent };